import {getAddressSuggestions} from '~/api/dadata';

/** @typedef { import('~/Autocomplete').AutocompleteDataset } AutocompleteDataset */

/** @typedef { import('./City').City } City */

/**
 * @this {City}
 * @returns {string}
 */
class City {
    toString() {
        const {region, text: city} = this;

        return region ? `${city}, ${region}` : city;
    }
}

/**
 *
 * @param {City} item
 */
function createCity(item) {
    const city = new City();

    Object.assign(city, item);

    return city;
}

/**
 *
 * @param {string} url
 */
export async function getCities(query) {
    const results = await getAddressSuggestions(query);

    if (results)
        return results.map(createCity);

    return [];
}

/** @return {AutocompleteDataset} */
export function getDataset() {
    return {
        name: 'default',
        displayKey: (suggestion) => suggestion.toString(),
        templates: {
            suggestion: (suggestion) => suggestion.toString(),
        },
        debounce: 350,
        cache: true,
    }
}
